import AuthService from './authService';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || 'https://api.beetlestore.online').replace(/\/$/, '');
const API_KEY     = process.env.REACT_APP_BACKEND_API_KEY || '';

/**
 * This seller's own notification inbox. Already populated by the backend
 * every time an order/delivery event fires for this shop — nothing new to
 * write, just the first UI to read it.
 */
async function apiFetch(path, opts = {}) {
  const uid = await AuthService.getCurrentUserId();
  const res = await fetch(`${BACKEND_URL}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': API_KEY,
      'X-User-Id': uid,
      ...(opts.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
  return data;
}

export function listNotifications() {
  return apiFetch('/api/notifications/list');
}

export function getUnreadCount() {
  return apiFetch('/api/notifications/unread-count');
}

export function markRead(notificationId) {
  return apiFetch(`/api/notifications/${notificationId}/read`, { method: 'POST' });
}

export function markAllRead() {
  return apiFetch('/api/notifications/read-all', { method: 'POST' });
}
